export default __webpack_public_path__ + "static/media/create@2x.917ee023.png";